function UserInfo(result) {
    this.EventsManager = new EventsManager();
    if (result[0] === undefined) {
        this.updateSeamlessData(result);
    }
    else {
        this.updateData(result);
    }
}

UserInfo.current = null;
UserInfo.onLogin = {};
UserInfo.onLogout = {};
UserInfo.onJWTUpdated = {};
UserInfo.onNotLoggedIn = {};
UserInfo.onLoginFailed = {};
UserInfo.onLoginSucceed = {}
UserInfo.onDataUpdated = {};
UserInfo.onUpdateBalance = {};
UserInfo.onGetBalance = {};
UserInfo.onLimitationsDataUpdated = {};
UserInfo.onCaptcha = {};
UserInfo.onTokenLogin = {};
UserInfo.OnTwoStepNativeLogin = {};

UserInfo.TaxProvider = EmptyTaxProvider;
UserInfo.onAcceptOddsChanged = {};

//dummy declaration
UserInfo.prototype.updateSeamlessData = function(data) {}
UserInfo.prototype.updateData = function(data) {}

window.UserInfo = UserInfo;